/**
 * 自用插件
 * 参数：
 * silent : 是否开启静默模式
 */

import installComponents from "./install/component"
import installMixins from "./install/mixin"
import installDirectives from "./install/directive"
import installFilters from "./install/filter"
import installProtos from "./install/proto"

const plugin = {
    install(Vue, { silent } = {}) {
        this.setLog(silent)
        // 安装组件
        installComponents(Vue)
        // 安装混入Mixin
        installMixins(Vue)
        // 安装指令
        installDirectives(Vue)
        // 安装过滤器
        installFilters(Vue)
        // 安装实例扩展
        installProtos(Vue)
    },
    // 修改全局log变为可控
    setLog(silent){
        let old = console.log
        console.log = (...str) => {
            if (!silent) {
                old(...str)
            }
        }
    }
}


export default plugin